export default __webpack_public_path__ + "static/media/aqi-moderate.33db7540.svg";